import { useIsSubmitting } from 'remix-validated-form'
import Button, { ButtonProps } from '../Button'

type SubmitButtonProps = Omit<ButtonProps, `type` | `disabled`>
export default function SubmitButton(props: SubmitButtonProps) {
  const isSubmitting = useIsSubmitting()

  const mergedProps = {
    ...props,
    label: isSubmitting ? `Submitting...` : props.label,
  }
  return <Button {...mergedProps} type="submit" />
}
